<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="Action">
        <app-fsm-territory-action></app-fsm-territory-action>
    </p-tabPanel>
    <!-- <p-tabPanel header="Type">
        <app-fsm-territory-type></app-fsm-territory-type>
    </p-tabPanel> -->
  
    <!-- <p-tabPanel [disabled]="true" headerStyleClass="iconPanel" appendTo="body">
      <ng-template pTemplate="header">
        <p-menu #configmenuFsm id="config_menu_fsm" [model]="configMenuItems" [popup]="true"
          appendTo="body">
        </p-menu>
        <span class="btnBars p-mr-0" (click)="configmenuFsm.toggle($event)">
          <i class="pi pi-bars"></i>
        </span>
      </ng-template>
    </p-tabPanel> -->
</p-tabView>
